import Plotly from "plotly.js";
import { useContext, useEffect } from "react";

import { TimelineContext } from "../timeline-chart";

// See https://plotly.com/javascript/reference/layout/#layout-showlegend
// for more information on legend properties
const defaultLegend: Partial<Plotly.Legend> = {
  x: 0.02,
  xanchor: "left",
  y: 1,
  yanchor: "auto",
  borderwidth: 1,
  bordercolor: "rgba(0,0,0,0.4)",
  bgcolor: "rgba(255,255,255,0.4)",
};

type LegendProps = Partial<Plotly.Legend>;

export function Legend(props: LegendProps) {
  const { dispatch } = useContext(TimelineContext);

  // Dispatch an action to set the legend in the state
  dispatch({
    type: "SET_LEGEND",
    legend: { ...defaultLegend, ...props },
  });

  useEffect(() => {
    // Cleanup function to reset the legend when the component is unmounted
    return () => {
      dispatch({ type: "SET_LEGEND", legend: undefined });
    };
  }, [dispatch]);

  return null; // This component does not render anything visually
}
